import * as React from 'react';
import Coin from 'components/Coin';
import Glyph from 'components/Glyph';
import DeliveryStatus from 'constants/DeliveryStatus';

import './styles/DeliveryStatusIcon.scss';

const Icon = (props: any) => (
  <Coin
    size="small"
    className="DeliveryStatusIcon"
    border={props.coinBorderColor}
    color={props.coinBackgroundColor}
  >
    <Glyph
      solo
      name={props.glyphName}
      color={props.glyphColor}
      className="DeliveryStatusIcon-glyph"
    />
  </Coin>
);

type Props = {
  status: string;
};

class DeliveryStatusIcon extends React.Component<Props, {}> {
  render() {
    switch (this.props.status) {
      case DeliveryStatus.DELIVERY_ERROR:
        return (
          <Icon
            glyphName="explanation"
            glyphColor="pencil"
            coinBorderColor="pencil"
            coinBackgroundColor="whiteout"
          />
        );
      case DeliveryStatus.READ:
        return (
          <Icon
            glyphName="check"
            glyphColor="whiteout"
            coinBorderColor="mascot"
            coinBackgroundColor="mascot"
          />
        );
      case DeliveryStatus.SENT:
        return (
          <Icon
            glyphName="check"
            glyphColor="atlas"
            coinBorderColor="atlas"
            coinBackgroundColor="whiteout"
          />
        );
      case DeliveryStatus.DELIVERED:
        return (
          <Icon
            glyphName="check"
            glyphColor="whiteout"
            coinBorderColor="atlas"
            coinBackgroundColor="atlas"
          />
        );
      default:
        return null;
    }
  }
}

export default DeliveryStatusIcon;
